export default "__VITE_ASSET__4Uv8lT$6__"